import React, { useState, useEffect } from "react";
import "../../assets/styles/DirectChat.css";
import supabase from "../../lib/supabase";

// const url = "http://localhost:9999/";
const url = process.env.REACT_APP_BACKEND;

const DirectChat = () => {
  const [subscriptions, setSubscriptions] = useState([]);
  const [selectedSubscription, setSelectedSubscription] = useState(null);
  const [messages, setMessages] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [anno, setAnon] = useState(true);
  const [loading, setLoading] = useState(false);
  const [newMessage, setNewMessage] = useState({
    title: "",
    content: "",
    sender_type: "admin",
  });
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [active, setActive] = useState(true);

  // Fetch subscriptions on component mount
  useEffect(() => {
    const fetchSubscriptions = async () => {
      // Adjust the table and column names to match your schema
      const { data, error } = await supabase.from("subscriptions").select("*");
      console.log(data);

      if (error) {
        console.error("Error fetching subscriptions:", error);
      } else {
        setSubscriptions(data);
      }
    };

    fetchSubscriptions();
  }, []);

  useEffect(() => {
    // Create a realtime channel
    let unique_id = localStorage.getItem("unique_id");
    const channel = supabase
      .channel("visitor-messages")
      .on(
        "postgres_changes",
        {
          event: "INSERT",
          schema: "public",
          table: "messages",
          // filter: `sender_type=neq.${unique_id}`,
          filter: `sender_type=neq.admin`,
        },
        (payload) => {
          console.log("📩 New visitor message:", payload.new);

          // Open your modal on new message

          // Find the subscription for the visitor
          const matched = subscriptions.filter(
            (x) => x.visitor_id === payload.new.visitor_id
          );

          // Call your function to handle selected subscription
          if (matched) {
            setSelectedSubscription(matched);
          }

          // Add message to local state
          setMessages((prev) => [...prev, payload.new]);
          setModalOpen(true);
          setActive(true);
        }
      )
      .subscribe((status) => {
        console.log("🟢 Realtime subscription status:", status);
      });

    // Cleanup on unmount
    return () => {
      supabase.removeChannel(channel);
    };
  }, []);

  const sendAdminMessage = async () => {
    let unique_id = localStorage.getItem("unique_id");
    const { data, error } = await supabase.from("messages").insert([
      {
        sender_type: "admin",
        visitor_id: "ss",
        sender_id: unique_id,
        content: newMessage.content,
      },
    ]);

    if (error) console.error("Error sending:", error);
    else console.log("Message sent:", data);
    setMessages((prev) => [...messages, newMessage]);
    setNewMessage({ content: "", title: "", sender_type: "admin" });
  };

  const tt = () => {
    console.log(messages);
  };

  // Effect for WebSocket connection (mostly unchanged)
  //   useEffect(() => {
  //     const ws = new WebSocket("ws://localhost:8080"); // Replace with your WebSocket server URL
  //     ws.onopen = () => {
  // // ... existing code ...
  //     ws.onmessage = (event) => {
  //       const message = JSON.parse(event.data);
  //       // TODO: You may want to check if the message belongs to the selected conversation
  //       setMessages((prevMessages) => [...prevMessages, message]);
  //     };
  //     ws.onclose = () => {
  // // ... existing code ...
  //     };
  //     return () => {
  //       ws.close();
  //     };
  //   }, []);

  // When a subscription is selected, fetch its message history
  // useEffect(() => {
  //   if (!selectedSubscription) return;

  //   // TODO: Implement logic to fetch message history for the selected user
  //   // For now, we'll just clear the messages
  //   setMessages([]);
  //   console.log(`Switched to subscription: ${selectedSubscription.id}`);
  // }, [selectedSubscription]);

  const sendMessage = async (e) => {
    try {
      if (newMessage.content.length < 2) {
        setError("Enter text");
        return;
      }
      e.preventDefault();
      if (anno) {
        sendAdminMessage();
      }
      setAnon(false);

      if (active) {
        sendAdminMessage();
        return;
      }
      setMessages((prev) => [...messages, newMessage]);
      setNewMessage({ body: "", title: "", sender_type: "admin" });
      console.log(selectedSubscription);
      // let subscription1 = {
      //   endpoint: selectedSubscription.endpoint,
      //   key: selectedSubscription.key,
      //   p256dh: selectedSubscription.p256dh_key,
      //   expires_at: "",
      // };
      const res = await fetch(url + "send-push", {
        method: "POST",
        headers: {
          Accept: "application/json",
        },
        body: JSON.stringify({
          // subscription: subscription1,
          subscription: selectedSubscription,
          message: {
            title:
              newMessage.title.length > 1 ? newMessage.title : "New Message",
            body: newMessage.content,
          },
        }),
      });
      const json = await res.json();
      console.log(json);
      setMessages((prev) => [...messages, newMessage]);
      setNewMessage({ content: "", title: "", type: "admin" });
    } catch (error) {
      console.log("error occured in sending message", error);
    }
  };

  return (
    <div className="overflow-x-auto flex justify-center w-full">
      <div className="w-full max-w-6xl">
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-lg">Chat Messages</h3>
          <button
            className="px-3 py-2 bg-blue-600 rounded"
            onClick={() => setModalOpen(true)}
          >
            New Project
          </button>
        </div>
        <table className="w-full bg-gray-900 text-white border border-gray-700 rounded-lg shadow-lg">
          <thead className="bg-gray-800">
            <tr className="text-left">
              <th className="py-4 px-6 border-b border-gray-700 w-12">#</th>
              <th className="py-4 px-6 border-b border-gray-700 w-64">email</th>

              <th className="py-4 px-6 border-b border-gray-700 w-48">Link</th>
              <th className="py-4 px-6 border-b border-gray-700 w-40">
                Created
              </th>
              <th className="py-4 px-6 border-b border-gray-700 w-32 text-center">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="7" className="text-center py-6 text-gray-400">
                  Loading...
                </td>
              </tr>
            ) : subscriptions.length > 0 ? (
              subscriptions.map((item, index) => (
                <tr key={item.id} className="hover:bg-gray-800">
                  <td className="py-3 px-6 border-b border-gray-700">
                    {index + 1}
                  </td>
                  <td className="py-3 px-6 border-b border-gray-700">
                    {item.email}
                  </td>
                  <td className="py-3 px-6 border-b border-gray-700 truncate max-w-[360px]">
                    {item.endpoint}
                  </td>
                  <td className="py-3 px-6 border-b border-gray-700">
                    {item.created_at
                      ? new Date(item.created_at).toLocaleString()
                      : "-"}
                  </td>
                  <td className="py-3 px-6 border-b border-gray-700 text-center">
                    <div className="flex items-center justify-center gap-2">
                      <button
                        className="px-2 py-1 bg-gray-700 rounded"
                        onClick={() => {
                          setModalOpen(true);
                          setSelectedSubscription(item);
                          // sendMessage(item);
                        }}
                      >
                        Message
                      </button>
                      <button
                        className="px-2 py-1 bg-red-600 rounded"
                        // onClick={() => onClickDelete(project.id)}
                      >
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center py-6 text-gray-400">
                  No Subscriptions found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {modalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div
            className="absolute inset-0 bg-black/60"
            onClick={() => setModalOpen(false)}
          />
          <div className="relative z-10 w-full max-w-xl bg-gray-900 text-white p-6 rounded-lg border border-gray-700">
            <div className="flex items-center justify-between mb-4">
              <h4 className="text-lg">Send Message</h4>
              <button
                className="bg-gray-700 px-2 py-1 rounded"
                onClick={() => setModalOpen(false)}
              >
                Close
              </button>
            </div>
            <div className="chat-header">
              {/* Adjust to display user email or name */}
              <h2 onClick={tt}>
                Direct Chat with{" "}
                {selectedSubscription ? selectedSubscription.id : "NA"}
              </h2>
            </div>

            {success && <p className="text-green-400 mb-2">{success}</p>}
            {error && <p className="text-red-400 mb-2">{error}</p>}
            <div className="chat-messages">
              {messages.map((msg, index) => (
                <div key={index} className={`message ${msg.sender_type}`}>
                  <p>{msg.content}</p>
                </div>
              ))}
            </div>
            <div className="chat-input">
              <input
                type="text"
                value={newMessage.content}
                onChange={(e) =>
                  setNewMessage((prev) => ({
                    ...prev,
                    content: e.target.value,
                  }))
                }
                placeholder="Type your message..."
                // onKeyPress={(e) => e.key === "Enter" && sendMessage()}
              />
              <button onClick={sendMessage}>Send</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DirectChat;
